import { TextButton } from '@twistopayments/design-system/components/atoms/button'

import type { SectionsMoreComponent } from '@twisto/api-cms'

import { Headline } from '../../article-components'

import * as styles from './more.styles'

export const More = ({
  headline,
  cta,
  align = 'center',
}: SectionsMoreComponent) => (
  <section css={[styles.moreSection, styles[align]]}>
    {headline && <Headline name={headline} tag="h3" />}

    {cta?.text && cta.link && (
      <TextButton css={styles.cta} href={cta.link}>
        {cta.text}
      </TextButton>
    )}
  </section>
)
